import * as Mui from "@material-ui/core";

const getSizeStyles = (size) => {
  switch (size) {
    case 'sm':
      return {
        width: 30,
        height: 19,
        thumbSize: 13,
        marginTop: 1,
      };
    case 'lg':
      return {
        width: 40,
        height: 24,
        thumbSize: 17,
        marginTop: 1,
      };
    default: // md
      return {
        width: 35,
        height: 22,
        thumbSize: 16,
        marginTop: 1,
      };
  }
};

const switchBase = (theme) => ({
  padding: 2,
  color: theme.palette.grey[500],
  transform: "translateX(2px)",
  "&$checked": {
    transform: "translateX(14px)",
    color: theme.palette.common.white,
    "& + $track": {
      opacity: 1,
      backgroundColor: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
    },
  },
})

const switchBaseSm = (theme) => ({
  ...switchBase(theme),
  "&$checked": {
    transform: "translateX(12px)",
    color: theme.palette.common.white,
    "& + $track": {
      opacity: 1,
      backgroundColor: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
    },
  },
})

const switchBaseLg = (theme) => ({
  ...switchBase(theme),
  "&$checked": {
    transform: "translateX(16px)",
    color: theme.palette.common.white,
    "& + $track": {
      opacity: 1,
      backgroundColor: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
    },
  },
})

const root = (theme, size) => ({
  width: getSizeStyles(size).width,
  height: getSizeStyles(size).height,
  padding: 2,
  color: theme.palette.grey[500],
})

const thumb = (size) => ({
  width: getSizeStyles(size).thumbSize,
  height: getSizeStyles(size).thumbSize,
  background: "#fff",
  marginTop: getSizeStyles(size).marginTop,
})

const track = {
  border: "none",
  borderRadius: 50,
  opacity: 1,
  backgroundColor: "#C4C4C4",
}


const StyledSwitch = Mui.withStyles((theme) => {
  return ({
    root: root(theme, "md"),
    switchBase: switchBase(theme),
    thumb: thumb("md"),
    track: track,
    checked: {},
  })
})(Mui.Switch);

export const StyledSwitchSm = Mui.withStyles((theme) => {
  return ({
    root: root(theme, "sm"),
    switchBase: switchBaseSm(theme),
    thumb: thumb("sm"),
    track: track,
    checked: {},
  })
})(Mui.Switch);

export const StyledSwitchLg = Mui.withStyles((theme) => {
  return ({
    root: root(theme, "lg"),
    switchBase: switchBaseLg(theme),
    thumb: thumb("lg"),
    track: track,
    checked: {},
  })
})(Mui.Switch);


export default StyledSwitch;